import LoadingScreen from '@/domains/shared/components/LoadingScreen';
import InlineLoader from '@/domains/shared/components/InlineLoader';

type LoadingVariant = 'app' | 'page' | 'inline';

type LoadingProps = {
  variant?: LoadingVariant;
  message?: string;
  screenReaderMessage?: string;
  className?: string;
};

export const Loading = ({
  variant = 'inline',
  message,
  screenReaderMessage,
  className,
}: LoadingProps) => {
  if (variant !== 'inline') {
    return (
      <LoadingScreen
        contained={variant === 'page'}
        message={message}
        screenReaderMessage={screenReaderMessage}
      />
    );
  }

  return (
    <InlineLoader
      message={message}
      screenReaderMessage={screenReaderMessage}
      className={className}
    />
  );
};
